import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toElement as scrollToElement } from '@utils/scroll';

import './style.scss';

class Nav extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleThemeApplied = this.handleThemeApplied.bind(this);
    this.state = { isSticky: false, themeName: '' };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('flapboard-theme-applied', this.handleThemeApplied);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('flapboard-theme-applied', this.handleThemeApplied);
  }

  handleThemeApplied(e) {
    this.setState({ themeName: e.detail.name });
  }

  handleScroll() {
    if (!this.nav) return;
    this.setState({ isSticky: window.pageYOffset > this.nav.offsetTop });
  }

  scrollToPage(pageSelector) {
    scrollToElement(document.querySelector(pageSelector));
  }

  shuffle() {
    document.dispatchEvent(new CustomEvent('flapboard-randomize'));
  }

  render() {
    const { colorPrimary } = this.context.theme;
    const { isSticky, themeName } = this.state;

    const pillClass = `nav-pill${isSticky ? ' nav-pill--sticky' : ''}`;

    return (
      <nav ref={(elem) => { this.nav = elem; }}>
        <style jsx="true">{`
          .theme-dot {
            background: ${colorPrimary};
            box-shadow: 0 0 6px ${colorPrimary}, 0 0 14px ${colorPrimary}66;
          }
        `}</style>

        <span className="nav-brand">DN</span>

        <div className={pillClass}>
          <span className="nav-pill__item" onClick={() => this.scrollToPage('.landing-page')}>Home</span>
          <span className="nav-pill__item" onClick={() => this.scrollToPage('#about')}>About</span>
          <span className="nav-pill__item" onClick={() => this.scrollToPage('#experience')}>Experience</span>
          <span className="nav-pill__item" onClick={() => this.scrollToPage('#projects')}>Projects</span>
          <span className="nav-pill__item" onClick={() => this.scrollToPage('#contact')}>Contact</span>

          <div className="nav-pill__divider" />

          <div className="theme-btn" onClick={() => this.shuffle()}>
            <div className="theme-dot" />
            <span className="theme-label">Shuffle</span>
          </div>

          {themeName && (
            <span className="theme-name-display">{themeName}</span>
          )}
        </div>
      </nav>
    );
  }
}

Nav.contextTypes = {
  theme: PropTypes.any,
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js